import React from 'react';
import { Divider, Icon, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

// STORE
import { useActionsLeg } from '@/hooks/useActions';
import { AuthActions } from '@/store/actions';

import { ListItemStyled } from '../styles';

const BackToAdminMenuItem = () => {
  const [t] = useTranslation();
  const showBackToAdmin = useSelector(({ auth }) => auth.hasAdminToken && !auth.isAdmin);
  const [loginAsAdmin] = useActionsLeg([() => AuthActions.loginAs.action({ variant: 'admin' })]);

  if (!showBackToAdmin) {
    return null;
  }

  return (
    <>
      <Divider />
      <ListItemStyled onClick={loginAsAdmin}>
        <Icon className="m-r-10">exit_to_app</Icon>
        <Typography variant="body2" className="cut-text">
          {t('buttons.backToAdmin')}
        </Typography>
      </ListItemStyled>
    </>
  );
};

export default BackToAdminMenuItem;
